import { useTranslation } from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from '../TPCheckbox';
import { TextField } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export default function ExcelForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [stripQuotes, setStripQuotes] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);
  const [sheetName, setSheetName] = useState('');
  const [advanceCell, setAdvanceCell] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setSheetName(header.SHEET_NAME || '');
    setAdvanceCell(
      header.USE_LEGACY_NON_STREAMING ?
        (typeof header.USE_LEGACY_NON_STREAMING === 'boolean' && header.USE_LEGACY_NON_STREAMING) || header.USE_LEGACY_NON_STREAMING === "TRUE" || false
        : false
    );
    setStripQuotes(
      header.UNCSV ?
        (typeof header.UNCSV === 'boolean' && header.UNCSV) || header.UNCSV === "TRUE" || false
        : false
    );
    setTrimData(
      header.TRIMDATA ?
        (typeof header.TRIMDATA === 'boolean' && header.TRIMDATA) || header.TRIMDATA === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

 

  return (
    <>
      <>
        <TextField 
          className="width-100"
          label={t('LBL_SHEET_NAME')} 
          variant="outlined" 
          size="small"
          placeholder=''
          value={sheetName}
          onChange={(e) => {
            setSheetName(e.target.value);
            handleChange('SHEET_NAME', e.target.value);
          }}
        />
      </>
      <div className="flex flex-wrap">
        <TPCheckbox
          label={t('BTN_USE_LEGACY_NON_STREAMING')}
          checked={advanceCell}
          handleCheck={(checked) => {
            setAdvanceCell(checked);
            handleChange('USE_LEGACY_NON_STREAMING', checked);
          }}
        />
        <TPCheckbox
          label={t('BTN_STRIP_QUOTES')}
          checked={stripQuotes}
          handleCheck={(checked) => {
            setStripQuotes(checked);
            handleChange('UNCSV', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_TRIM_DATA')}
          checked={trimData}
          handleCheck={(checked) => {
            setTrimData(checked);
            handleChange('TRIMDATA', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_URLDECODE_DATA')}
          checked={decodeData}
          handleCheck={(checked) => {
            setDecodeData(checked);
            handleChange('URLDECODE', checked);
          }}
        />
      </div>

      <GroupByName />
    </>
  )
}
